/* TOMOSHIN 共通スクリプト：メニュー開閉・ふわっと表示・トースト・カート数 */
(function () {
  'use strict';

  /* ---- トースト ---- */
  var toastTimer;
  window.tmToast = function (html) {
    var toast = document.getElementById('tm-toast');
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4000);
  };

  /* ---- カート数の更新 ---- */
  window.tmUpdateCartCount = function (count) {
    document.querySelectorAll('[data-tm-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  };

  function initMenu(scope) {
    (scope || document).querySelectorAll('[data-tm-menu-button]').forEach(function (button) {
      if (button.dataset.tmBound) return;
      button.dataset.tmBound = '1';
      var nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      var close = function () {
        nav.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'メニューを開く');
      };
      button.addEventListener('click', function () {
        var open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      });
      nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.tm-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initBackToTop(scope) {
    (scope || document).querySelectorAll('[data-tm-back-to-top]').forEach(function (b) {
      b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    });
  }

  /* TOP商品紹介：サムネイルでカラー名・画像を切り替え */
  function initShowcase(scope) {
    (scope || document).querySelectorAll('[data-tm-showcase]').forEach(function (root) {
      var label = root.querySelector('[data-tm-showcase-label]');
      var mainImg = root.querySelector('[data-tm-showcase-main] img');
      var nameEl = root.querySelector('[data-tm-showcase-name]');
      var priceEl = root.querySelector('[data-tm-showcase-price]');
      var leadEl = root.querySelector('[data-tm-showcase-lead]');
      var links = root.querySelectorAll('[data-tm-showcase-link]');
      // 最初に表示している商品情報（T-mist mini）を覚えておく
      var base = {
        name: nameEl ? nameEl.innerHTML : '',
        price: priceEl ? priceEl.innerHTML : '',
        lead: leadEl ? leadEl.innerHTML : '',
        url: links.length ? links[0].getAttribute('href') : ''
      };
      function setInfo(info) {
        if (nameEl) nameEl.innerHTML = info.name;
        if (priceEl) priceEl.innerHTML = info.price;
        if (leadEl) leadEl.innerHTML = info.lead;
        links.forEach(function (a) { a.setAttribute('href', info.url); });
      }
      // 最初に選択されているサムネイルを押したときは、最初のメイン画像に戻す
      var initial = mainImg ? { src: mainImg.getAttribute('src'), srcset: mainImg.getAttribute('srcset'), alt: mainImg.alt } : null;
      root.querySelectorAll('[data-tm-showcase-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          root.querySelectorAll('[data-tm-showcase-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
          thumb.setAttribute('aria-pressed', 'true');
          if (thumb.hasAttribute('data-tm-other')) {
            // 別の商品（専用アロマオイルなど）の情報に切り替え
            setInfo({ name: thumb.dataset.name, price: thumb.dataset.price, lead: thumb.dataset.lead, url: thumb.dataset.url });
            if (label) label.textContent = thumb.dataset.sub || '';
          } else {
            setInfo(base);
            if (label) label.textContent = thumb.dataset.label || '';
          }
          if (mainImg && thumb.hasAttribute('data-tm-initial') && initial) {
            mainImg.src = initial.src;
            if (initial.srcset) mainImg.setAttribute('srcset', initial.srcset);
            mainImg.alt = initial.alt;
          } else if (mainImg && thumb.dataset.image) {
            mainImg.src = thumb.dataset.image;
            mainImg.removeAttribute('srcset');
            mainImg.alt = thumb.dataset.alt || '';
          }
        });
      });
    });
  }

  /* お問い合わせフォーム：送信前チェック */
  function initContactForm(scope) {
    (scope || document).querySelectorAll('[data-tm-contact-form]').forEach(function (form) {
      var fields = form.querySelectorAll('[required]');
      var check = function (field) {
        var ok = field.type === 'checkbox' ? field.checked : field.checkValidity();
        if (ok && field.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value);
        var wrap = field.closest('.tm-field');
        if (wrap) wrap.classList.toggle('has-error', !ok);
        field.setAttribute('aria-invalid', String(!ok));
        return ok;
      };
      fields.forEach(function (f) {
        f.addEventListener('blur', function () { check(f); });
        f.addEventListener('change', function () { check(f); });
      });
      form.addEventListener('submit', function (e) {
        var results = Array.prototype.map.call(fields, check);
        if (results.indexOf(false) !== -1) {
          e.preventDefault();
          var first = form.querySelector('[aria-invalid="true"]');
          if (first) first.focus();
        }
      });
    });
  }

  function initAll(scope) {
    initMenu(scope);
    initReveal(scope);
    initBackToTop(scope);
    initShowcase(scope);
    initContactForm(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* テーマエディタでセクションを再読み込みしたとき */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
